<template>
    <div class="card-body scrollable-content pt-2">
        <div class="container">
            <div class="card-header pl-0">
                <div>
                    <h4>Productos pedido: <b>{{ qr_code }}</b></h4>
                </div>
            </div>
            <div class="card-body pl-0">
                <div
                    v-for="producto in productos"
                    :key="producto.id"
                    class="d-flex align-items-center"
                >
                    <div class="custom-control custom-checkbox">
                        <input 
                            class="custom-control-input" 
                            type="checkbox" 
                            :id="'producto-' + qr_code + '-' + producto.id" 
                            :value="{ id: producto.id, qr_code: qr_code }"
                            v-model="productosSeleccionados"
                        />
                        <label class="custom-control-label" :for="'producto-' + qr_code + '-' + producto.id">
                            {{ producto.nombre }} - {{ producto.description }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer text-right p-3">
            <slot name="footer">
                <div class="d-flex justify-content-between align-items-center">
                    <button 
                        class="btn btn-primary" 
                        @click="validarProductos"
                        :disabled="productosSeleccionados.length === 0"
                    >
                        Continuar
                    </button>
                    <Button type="button" name="button" @click.prevent="close()">CERRAR</Button>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['productos', 'qr_code'],
        data() {
            return {
                productosSeleccionados: []
            }
        },
        methods: {
            validarProductos() {
                this.$emit("confirm", this.productosSeleccionados);
            },
            close() {
                this.$emit("close");
            }
        }
    }
</script>